module.exports = __webpack_public_path__ + "img/5.1d053064.svg";